module.exports = __webpack_public_path__ + "img/warcraft-iii.1c221702.svg";